export default __webpack_public_path__ + "static/media/filter.22389c20.svg";